
    var riot = require('riot')
    
riot.tag2('video-popup', '<a onclick="{tags.modal1.show}" class="btn btn-primary btn-outline">Watch our video</a> <modal name="modal1" onclose="{true}" bssize="lg"> <div style="padding:56.25% 0 0 0;position:relative;"> <iframe src="https://player.vimeo.com/video/245799401?title=0&amp;byline=0&amp;portrait=0" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe> </div> </modal>', '', '', function(opts) {
});
    
  